import appInfo from '@/app-info'
import axios from 'axios'
import router from '@/router'

var userId = ''
var passwordRequired = false
var password = ''
var passwordVerified = ''

const emptyData = {
  Address: '',
  Username: '',
  Fullname: '',
  Email: '',
  Password: '',
  RolesName: [],
  CustomerName: []
}

var validateName = async (name) => {
  try {
    var idParam = ''
    var id = userId ? userId : router.history.current.params.id

    if (id) {
      idParam = `&userId=${id}`
    }
    const res = await axios.get(
      appInfo.api.user.isAvailableUsername + '?username=' + name + idParam
    )
    return res.data
  } catch (e) {
    console.log(e)
  }
}

var validateUsername = async (rule, value, callback) => {
  var regexExpression = new RegExp('^[a-z0-9_-]{3,255}$')

  if (value == '') {
    callback(new Error('Username is required'))
  } else if (!(await validateName(value))) {
    callback(new Error('Username Already used'))
  } else if (!regexExpression.test(value)) {
    callback(
      new Error(
        'Invalid Username, Min. 3 characters and Max. 255 characters, and cannot use special characters'
      )
    )
  } else {
    callback()
  }
}

var validateEmail = async (rule, value, callback) => {
  const regexExp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  if (!regexExp.test(value)) {
    callback(new Error('Email format is incorrect'))
  } else if (value == '') {
    callback(new Error('Email is required'))
  } else {
    callback()
  }
}

var validatePassword = async (rule, value, callback) => {
  const regexExp = new RegExp(
    '^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.{8,})'
  )
  // assign password
  password = value

  if (!regexExp.test(value) && value.length > 0) {
    callback(
      new Error(
        'At least 8 characters long, contain uppercase lowercase letters, and special characters'
      )
    )
  } else if (value == '' && passwordRequired) {
    callback(new Error('Password is required'))
  } else {
    callback()
  }
}

var validatePasswordConfirmation = async (rule, value, callback) => {
  const regexExp = new RegExp(
    '^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.{8,})'
  )
  // assign password
  passwordVerified = value

  if (value !== password && password !== '') {
    callback(new Error("Password confirmation doesn't match"))
  } else if (!regexExp.test(value) && password !== '' && value !== '') {
    callback(
      new Error(
        'At least 8 characters long, contain uppercase lowercase letters, and special characters'
      )
    )
  } else if (value === '' && passwordRequired) {
    callback(new Error('Password Confirmation is required'))
  } else {
    callback()
  }
}

var validationRules = {
  Username: [
    {
      required: true,
      trigger: 'change',
      validator: validateUsername
    }
  ],
  Fullname: [
    {
      required: true,
      trigger: 'change'
    }
  ],
  Email: [
    {
      required: true,
      trigger: 'change',
      validator: validateEmail
    }
  ],
  Password: [
    {
      required: passwordRequired,
      trigger: 'change',
      validator: validatePassword
    }
  ],
  PasswordVerified: [
    {
      required: passwordRequired,
      trigger: 'change',
      validator: validatePasswordConfirmation
    }
  ],
  Role: [
    {
      required: true,
      trigger: 'blur'
    }
  ],
  RolesName: [
    {
      required: true,
      message: 'At least select one Role',
      trigger: 'blur'
    }
  ],
  CustomerName: []
  // CustomerName: [{
  // 	required: true,
  // 	message: 'At least select one Tenant',
  // 	trigger: 'change'
  // }],
}

export default {
  getEmptyData() {
    return emptyData
  },
  getValidationRule() {
    return validationRules
  },
  setUserId(id) {
    userId = id
  },
  setPasswordRequired(isRequired = true) {
    passwordRequired = isRequired
  }
}
